import { DEFAULT_LOCALE, Locale } from '../commonFormatters'
import { BlockDefinitionArray } from './blocks/blocks.schema'
import { BlockType } from './blocks/types'

export const CmsPageAttachmentKind = {
    EVENT: 'EVENT',
    LIFESTYLE_PROGRAM: 'LIFESTYLE_PROGRAM',
} as const

export type CmsPageAttachmentKind =
    (typeof CmsPageAttachmentKind)[keyof typeof CmsPageAttachmentKind]

export const EVENT_PAGE_SECTIONS = {
    booking: 'event-booking',
    packages: 'event-package-select',
    description: 'event-description',
} as const

export type EventPageSection = keyof typeof EVENT_PAGE_SECTIONS

export type CmsAttachedBlocks = Partial<Record<Locale, BlockDefinitionArray>>

const COMPACT_BLOCK_TYPES: ReadonlySet<BlockType> = new Set([BlockType.TEXT, BlockType.IMAGE])

export const pickCompactBlocks = (blocks: BlockDefinitionArray): BlockDefinitionArray =>
    blocks.filter((block) => COMPACT_BLOCK_TYPES.has(block.type))

export const pickAttachedBlocks = (
    attached: CmsAttachedBlocks | null | undefined,
    locale: Locale,
): BlockDefinitionArray => {
    const localized = attached?.[locale]
    if (localized && localized.length > 0) return localized
    return attached?.[DEFAULT_LOCALE] ?? []
}
